export default __webpack_public_path__ + "static/media/oie.9888d746.jpg";